import React, { useEffect, useRef, useState } from "react";
import { FiMapPin, FiPhone, } from "react-icons/fi";
import { CiInstagram } from "react-icons/ci";
function HotelService() {
  const images = [
    "hotel-1","hotel-3","hotel-4","hotel-5",
    "hotel-7","hotel-8","hotel-9",
    "hotel-a","hotel-b","hotel-c","hotel-d","hotel-e"
  ];

  const [visibleCount, setVisibleCount] = useState(6);

  return (
    <>
      <main className="main">

        {/* Page Title */}
        <div className="page-title dark-background">
          <div className="container text-center">
            <h1 className="page-heading">Hotels & Hospitality</h1>
            <p className="page-subtitle">
              High-quality meals and exceptional service in Makkah
            </p>

            <nav className="breadcrumbs">
              <ol>
                <li><a href="/">Home</a></li>
                <li className="current">Hotels & Hospitality</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Overview & Branch Profile */}
        <section className="service-details section">
          <div className="container">

            {/* Main Image */}
            <div className="main-image-container">
              <img src="/assets/hotel/hotel-5.webp" alt="Hotel Services" className="main-image" />
            </div>

            <h2>Overview</h2>
            <p>
              Our Makkah branch operates as a dedicated food service restaurant delivering high-quality meals with a focus on taste, hygiene, and customer satisfaction. Located in Haram, Makkah-Saudi Arabia, this branch serves a wide range of customers, including local residents, pilgrims, and visitors from across the world.
            </p>

            <h2>Products</h2>
            <p>
              Our restaurant proudly serves a wide range of fresh and flavorful dishes, specially crafted for customers visiting the holy city of Makkah. Each dish is made with care, quality ingredients, and consistent taste across all our branches within the Haram boundary.
            </p>

            {/* Product Categories */}
            <h3>Signature Dishes</h3>
            <div className="product-row">
              <span>Broast Chicken</span>
              <span>Shawarma</span>
              <span>Chicken Nuggets</span>
              <span>Al-Faham (charcoal-grilled)</span>
              <span>Mandi (fragrant rice & tender chicken)</span>
            </div>

            {/* <h3>Arabian Cuisine</h3>
            <div className="product-row">
              <span>Hummus</span>
              <span>Falafel</span>
              <span>Tabbouleh</span>
              <span>Arabic bread / Pita</span>
            </div> */}

            {/* <h3>Beverages & Desserts</h3>
            <div className="product-row">
              <span>Fresh juices</span>
              <span>Soft drinks</span>
              <span>Tea & Coffee</span>
              <span>Traditional desserts</span>
              <span>Cakes & puddings</span>
            </div> */}

          </div>
        </section>

        {/* Gallery Section */}
        <section className="catering-gallery section">
          <div className="container">
            <div className="section-title text-center">
              <h2>Gallery</h2>
              <p>Freshly prepared dishes and restaurant highlights</p>
            </div>

            <div className="gallery-grid">
              {images.slice(0, visibleCount).map((img, index) => (
                <LazyImage
                  key={img}
                  src={`/assets/hotel/${img}.webp`}
                  alt={`Hotel ${index + 1}`}
                  priority={index === 0}
                />
              ))}
            </div>

            {visibleCount < images.length && (
              <div className="load-more">
                <button onClick={() => setVisibleCount(v => v + 6)}>Load More</button>
              </div>
            )}
          </div>
        </section>

        {/* Location & Contact */}
        <section className="contact-strip">
          <div className="container">
            <h3 className="contact-heading">Visit & Contact Us</h3>
            <div className="contact-row">
              <span><FiMapPin /> Al Haram, Makkah 24231</span>
              <span><FiPhone /> +966 5541067771</span>
              {/* <span><FiMail /> info@yourmail.com</span> */}
              <a
                 href="https://www.instagram.com/almac_company?igsh=MThmemIyN2d6aG8zeQ=="
                 target="_blank"
                rel="noopener noreferrer"
                  >
                <CiInstagram style={{ fontSize: '28px', color: '#111' }} />
                </a>
            </div>
          </div>
        </section>

      </main>

      {/* Styles */}
      <style>{`
        /* PAGE TITLE */
        .page-heading {
          font-size: 2.6rem;
          font-weight: 800;
          color: #fff;
          text-shadow: 1px 1px 2px rgba(0,0,0,0.4);
          letter-spacing: 0.5px;
        }
        .page-subtitle {
          font-size: 1.1rem;
          color: #e6e6e6;
        }

        /* MAIN IMAGE */
        .main-image-container {
          text-align: center;
          margin-bottom: 35px;
        }
        .main-image {
          width: 100%;
          max-width: 900px;
          height: auto;
          border-radius: 12px;
        }

        /* TEXT CONTENT */
        h2 {
          font-size: 2rem;
          margin-top: 30px;
          margin-bottom: 15px;
          color: #222;
        }
        h3 {
          font-size: 1.5rem;
          margin-top: 20px;
          margin-bottom: 10px;
          color: #333;
        }
        p {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #555;
          margin-bottom: 15px;
        }

        /* PRODUCTS FLEX GRID */
        .product-row {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          font-size: 1.05rem;
          color: #555;
          margin-bottom: 20px;
        }
        .product-row span {
          background: #f5f5f5;
          padding: 6px 12px;
          border-radius: 8px;
        }

        /* GALLERY */
        .gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-top: 35px;
        }
        .img-wrapper {
          width: 100%;
          height: 230px;
          border-radius: 14px;
          overflow: hidden;
          background: #f2f2f2;
        }
        .img-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.25s ease;
        }
        .img-wrapper:hover img {
          transform: scale(1.04);
        }
        .load-more {
          text-align: center;
          margin-top: 40px;
        }
        .load-more button {
          padding: 12px 30px;
          border-radius: 30px;
          border: none;
          background: #111;
          color: #fff;
          cursor: pointer;
          font-size: 15px;
        }

        @media (max-width: 991px) {
          .gallery-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 576px) {
          .gallery-grid { grid-template-columns: 1fr; }
          .product-row { flex-direction: column; gap: 10px; }
        }

        /* CONTACT */
        .contact-strip {
          background: #fafafa;
          border-top: 1px solid #eee;
          margin-top: 70px;
          padding: 45px 0;
        }
        .contact-heading {
          text-align: center;
          font-size: 1.7rem;
          font-weight: 700;
          margin-bottom: 25px;
          color: #222;
        }
        .contact-row {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 30px;
          flex-wrap: wrap;
          font-size: 0.95rem;
          color: #333;
        }
        .contact-row span, .contact-row a {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #333;
          text-decoration: none;
          font-weight: 500;
          white-space: nowrap;
        }
        .contact-row svg {
          font-size: 1.2rem;
          color: #111;
        }
      `}</style>
    </>
  );
}

/* ---------- LAZY IMAGE COMPONENT ---------- */
function LazyImage({ src, alt, priority }) {
  const ref = useRef(null);
  const [show, setShow] = useState(priority);

  useEffect(() => {
    if (priority) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { rootMargin: "150px" }
    );

    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [priority]);

  return (
    <div className="img-wrapper" ref={ref}>
      {show && (
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
        />
      )}
    </div>
  );
}

export default HotelService;
